// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1uN5D","range":"MonthRangeSwitch_range__28d8k","disabled":"MonthRangeSwitch_disabled__1Oet-"};